import type {ReactElement} from 'react';
import {Text, TextSize} from '@Components/text';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import styles from './ticketing-required-pill.module.scss';

export function TicketingRequiredPill(): ReactElement {
  return (
    <div className={`${styles.requiredPill} gap-1 bg-error-tertiary-default flex-row-align-center corner-radius-full`}>
      <Icon className="ct-error-primary" icon="icon-asterisk" size={IconSize.SIZE_ICON_16} />
      <Text className="ct-error-primary" val={window.i18next.t('pmwjs_event_ticketing_required_pill')} size={TextSize.SM} bold />
    </div>
  );
}
